import React from 'react'
import { Divider } from 'antd'
import ConditionalHideWrap from './ConditionalHidewrap'
import HealthCard from '../../healthScore/card'
import Information from '../../UI/extraInformation'
import { MenopauseBarChart } from './MenopauseBarChart'
import FemaleSprint from '../../../asserts/images/FemaleSprint.svg'
import './Menopause.css'
import { menopauseScoreConfig } from '../comp/HSDContainer'
import moment from 'moment'

function Menopause(props) {
  const {
    hideSection,
    hideSectionHandle,
    view,
    save,
    loginRole,
    status,
    onScoreChangeHandle,
    cancelEdit,
    handleCommendSave,
    updateEditingCount,
    arDetail: { notes },
    dynamicData
  } = props

  const menopause =
    (notes && notes.find((item) => item.pillar === 'menopause')) || {}

  const menopauseScore =
    (dynamicData &&
      dynamicData.lifeStyleSummary &&
      dynamicData.lifeStyleSummary.lifestyleScore &&
      dynamicData.lifeStyleSummary.lifestyleScore.menopause &&
      dynamicData.lifeStyleSummary.lifestyleScore.menopause.score) ||
    {}

  const menopauseCompletionDate = (dynamicData &&
    dynamicData.lifeStyleSummary &&
    dynamicData.lifeStyleSummary.lifestyleScore &&
    dynamicData.lifeStyleSummary.lifestyleScore.menopause &&
    dynamicData.lifeStyleSummary.lifestyleScore.menopause.completion_date) || '--' 

  const symptomsReported =
    (menopauseScore && menopauseScore.symptoms_reported) || '--'
  const severityPercentage =
    (menopauseScore && menopauseScore.severity_percentage) || '--'
  const categorySeverityPercentages =
    (menopauseScore && menopauseScore.category_severity_percentages) || []
  const categorySymptomSeverityLevels =
    (menopauseScore && menopauseScore.category_symptom_severity_levels) || []

  const symptomsColor =
    (menopauseScoreConfig(menopauseScore && menopauseScore.symptoms_reported) &&
      menopauseScoreConfig(menopauseScore && menopauseScore.symptoms_reported)
        .color) ||
    'grey'
  const severityColor =
    (menopauseScoreConfig(
      menopauseScore && menopauseScore.severity_percentage
    ) &&
      menopauseScoreConfig(menopauseScore && menopauseScore.severity_percentage)
        .color) ||
    'grey'

  return (
    <ConditionalHideWrap
      name="Menopause Profile"
      isSection={true}
      syncStatus={hideSectionHandle}
      status={hideSection}
      view={view}
      condition={
        view === 'Draft' ||
        (view === 'Preview' && !hideSection.includes('Menopause Profile'))
      }
    >
      <section>
        <h1 className="section-title">Menopause Profile</h1>
        <ConditionalHideWrap
          name="Menopause Profile - summary"
          title="summary"
          syncStatus={hideSectionHandle}
          status={hideSection}
          view={view}
          condition={
            view === 'Draft' ||
            (view === 'Preview' &&
              !hideSection.includes('Menopause Profile - summary'))
          }
        >
          <div className="sub-title">Summary</div>
          <HealthCard
            save={save}
            loginRole={loginRole}
            status={view === 'Draft' ? 'Draft' : 'Opened'}
            onChangeHandle={onScoreChangeHandle}
            disEdit={status === 1 || view === 'Preview'}
            cancel={cancelEdit}
            name="Symptoms Results"
            description="Menopause is a natural biological transition marking the end of a woman's reproductive years, officially diagnosed after 12 consecutive months without a menstrual period. It typically occurs around age 51, with perimenopause starting in the mid-to-late 40s and lasting 4 to 10 years. Postmenopause, when symptoms may persist but often lessen, brings increased risks of osteoporosis, heart disease, and metabolic changes due to sustained low estrogen levels."
            menopauseScore={
              (menopauseScore && menopauseScore.severity_percentage) || 0
            }
            compare={{}}
            globalEdit={false}
            type="menopause"
            latest_test_date={menopauseCompletionDate !== '--' ? moment(menopauseCompletionDate) : null}
            menopauseSeverityLevel={
              (menopauseScore && menopauseScore.severity_level) || 0
            }
          />
          <Information
            title="COMMENT/NOTE"
            disMarkDone={true}
            initialValue={(menopause && menopause.memo) || ''}
            status={view === 'Draft' ? 'Draft' : 'Opened'}
            updateCommend={(value, status) =>
              handleCommendSave(value, 'menopause', status)
            }
            updateEditingCount={updateEditingCount}
          />
          <Divider />
        </ConditionalHideWrap>

        <ConditionalHideWrap
          name="Menopause Survey Score - summary"
          title="Menopause Survey Score - summary"
          syncStatus={hideSectionHandle}
          status={hideSection}
          view={view}
          condition={
            view === 'Draft' ||
            (view === 'Preview' &&
              !hideSection.includes('Menopause Profile - summary'))
          }
        >
          <div className="menopause-score-container">
            <div className="score-wrapper">
              <div className="menopause-score">
                <div className="score-value-row">
                  <div
                    className="score-value"
                    style={{
                      color: symptomsColor
                    }}
                  >
                    {symptomsReported}
                  </div>
                  <div
                    className="score-value"
                    style={{
                      color: severityColor
                    }}
                  >
                    {severityPercentage}
                  </div>
                </div>
                <div className="score-header-row">
                  <div className="score-header">Symptoms Reported</div>
                  <div className="score-header">Symptoms Severity</div>
                </div>
              </div>

              {categorySeverityPercentages &&
                Object.keys(categorySeverityPercentages).length > 0 &&
                categorySymptomSeverityLevels &&
                Object.keys(categorySymptomSeverityLevels).length > 0 && (
                  <MenopauseBarChart
                    menopauseSurveyData={categorySeverityPercentages}
                    fullData={categorySymptomSeverityLevels}
                  />
                )}
            </div>
            <img
              className="female-sprint-img"
              src={FemaleSprint}
              alt="Female"
            />
          </div>
        </ConditionalHideWrap>
      </section>
    </ConditionalHideWrap>
  )
}

export default Menopause
